module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/ribbon/ribbon-style-1/ribbon-style-1.component.scss
// module id = ./src/app/features/ribbon/ribbon-style-1/ribbon-style-1.component.scss
// module chunks = main